module.exports = {
  jwt: '',
  lit: ''
}